const inactiveTimeout = async (db) => {
    return (await db.collection('config').doc('inactivity').get()).data()
}

module.exports = inactiveTimeout